var _path, _path2, _path3, _path4, _path5, _path6, _path7, _g, _path8, _g2, _path9, _path0, _g3, _g4, _g5, _g6, _g7, _g8, _g9, _g0, _g1, _path1, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _g10, _path20, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgStarbadge(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 316,
    height: 281,
    viewBox: "0 0 316 281",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18.2662 98.8009C19.3553 96.5329 22.5844 96.5322 23.6744 98.7998L26.7619 105.223C27.1926 106.119 28.0393 106.743 29.0225 106.89L36.0555 107.941C38.491 108.305 39.4751 111.286 37.7349 113.028L32.5478 118.221C31.8633 118.906 31.5518 119.88 31.7113 120.835L32.9225 128.089C33.3335 130.551 30.7343 132.409 28.5383 131.223L22.3947 127.906C21.505 127.426 20.4333 127.426 19.5438 127.907L13.4078 131.221C11.2118 132.407 8.61199 130.549 9.02303 128.087L10.2338 120.836C10.3933 119.88 10.0815 118.906 9.39661 118.221L4.20691 113.029C2.46572 111.287 3.44971 108.304 5.88576 107.941L12.9217 106.89C13.9055 106.743 14.7526 106.118 15.1831 105.222L18.2662 98.8009Z",
    fill: "#EEEEEE"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M293.229 96.9246C293.955 95.4126 296.108 95.4121 296.834 96.9238L301.053 105.7C301.34 106.298 301.905 106.714 302.56 106.812L312.078 108.234C313.702 108.476 314.358 110.464 313.198 111.625L306.246 118.585C305.79 119.042 305.582 119.691 305.688 120.328L307.321 130.104C307.595 131.745 305.862 132.984 304.398 132.194L295.981 127.65C295.388 127.33 294.674 127.33 294.081 127.65L285.671 132.192C284.207 132.983 282.474 131.744 282.748 130.103L284.38 120.328C284.487 119.691 284.279 119.042 283.822 118.585L276.866 111.626C275.706 110.464 276.362 108.476 277.986 108.234L287.508 106.812C288.164 106.714 288.728 106.297 289.015 105.7L293.229 96.9246Z",
    fill: "#EEEEEE"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M41.5923 51.1884C42.3117 49.6548 44.4925 49.654 45.213 51.187L46.4164 53.7474C46.6999 54.3506 47.2652 54.7729 47.924 54.8737L50.7708 55.3091C52.3797 55.5553 53.0366 57.5177 51.8999 58.6828L49.7146 60.9227C49.2711 61.3774 49.0698 62.0157 49.1725 62.6426L49.6729 65.698C49.9427 67.3459 48.1938 68.5793 46.7321 67.7719L44.3687 66.4664C43.7666 66.1339 43.0359 66.134 42.4339 66.4668L40.0744 67.7714C38.6135 68.5792 36.8643 67.3473 37.1327 65.6996L37.6309 62.6417C37.733 62.0153 37.5317 61.3777 37.0885 60.9234L34.903 58.6832C33.7662 57.5181 34.4232 55.5555 36.0324 55.3095L38.884 54.8737C39.5435 54.7729 40.1093 54.35 40.3926 53.746L41.5923 51.1884Z",
    fill: "#EEEEEE"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M276.642 51.1884C277.361 49.6548 279.542 49.654 280.262 51.187L281.466 53.7474C281.749 54.3506 282.315 54.7729 282.973 54.8737L285.82 55.3091C287.429 55.5553 288.086 57.5177 286.949 58.6828L284.764 60.9227C284.321 61.3774 284.119 62.0157 284.222 62.6426L284.722 65.698C284.992 67.3459 283.243 68.5793 281.782 67.7719L279.418 66.4664C278.816 66.1339 278.085 66.134 277.483 66.4668L275.124 67.7714C273.663 68.5792 271.914 67.3473 272.182 65.6996L272.68 62.6417C272.782 62.0153 272.581 61.3777 272.138 60.9234L269.952 58.6832C268.816 57.5181 269.473 55.5555 271.082 55.3095L273.933 54.8737C274.593 54.7729 275.159 54.35 275.442 53.746L276.642 51.1884Z",
    fill: "#EEEEEE"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M41.5923 163.349C42.3117 161.815 44.4925 161.814 45.213 163.347L46.4164 165.908C46.6999 166.511 47.2652 166.933 47.924 167.034L50.7708 167.469C52.3797 167.715 53.0366 169.678 51.8999 170.843L49.7146 173.083C49.2711 173.538 49.0698 174.176 49.1725 174.803L49.6729 177.858C49.9427 179.506 48.1938 180.739 46.7321 179.932L44.3687 178.627C43.7666 178.294 43.0359 178.294 42.4339 178.627L40.0744 179.932C38.6135 180.739 36.8643 179.507 37.1327 177.86L37.6309 174.802C37.733 174.175 37.5317 173.538 37.0885 173.084L34.903 170.843C33.7662 169.678 34.4232 167.716 36.0324 167.47L38.884 167.034C39.5435 166.933 40.1093 166.51 40.3926 165.906L41.5923 163.349Z",
    fill: "#EEEEEE"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M268.839 163.349C269.559 161.815 271.739 161.814 272.46 163.347L273.663 165.908C273.947 166.511 274.512 166.933 275.171 167.034L278.018 167.469C279.627 167.715 280.284 169.678 279.147 170.843L276.962 173.083C276.518 173.538 276.317 174.176 276.419 174.803L276.92 177.858C277.19 179.506 275.441 180.739 273.979 179.932L271.616 178.627C271.014 178.294 270.283 178.294 269.681 178.627L267.321 179.932C265.86 180.739 264.111 179.507 264.38 177.86L264.878 174.802C264.98 174.175 264.779 173.538 264.335 173.084L262.15 170.843C261.013 169.678 261.67 167.716 263.279 167.47L266.131 167.034C266.79 166.933 267.356 166.51 267.64 165.906L268.839 163.349Z",
    fill: "#EEEEEE"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M156.305 182.621L173.87 275.423L189.922 245.761L220.355 263.62L188.053 173.254L156.305 182.621Z",
    fill: "#FBD6CB"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 0.3
  }, /*#__PURE__*/React.createElement("path", {
    d: "M162.213 213.83C165.462 214.502 169.249 213.354 171.552 210.967C173.155 209.308 174.22 207.06 176.236 205.954C178.049 204.96 180.282 205.1 182.27 205.653C184.259 206.206 186.142 207.123 188.137 207.648C192.058 208.664 196.384 208.026 199.842 205.912L194.774 191.841L171.251 188.9L160.036 202.377L162.206 213.837L162.213 213.83Z",
    fill: "#F05A30"
  }))), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M158.874 187.451L141.309 280.253L125.256 250.591L94.8309 268.45L127.125 178.077L158.874 187.451Z",
    fill: "#FBD6CB"
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.3
  }, /*#__PURE__*/React.createElement("path", {
    d: "M117.471 205.107C117.471 205.107 122.47 209.216 128.428 207.326C134.385 205.429 138.089 205.03 141.316 207.326C144.543 209.622 153.273 217.099 153.273 217.099L155.297 206.395L143.57 190.293L131.326 192.764L122.603 193.632L119.362 199.765L117.464 205.107H117.471Z",
    fill: "#F05A30"
  }))), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M261.869 103.674C261.869 110.332 253.356 116.065 252.11 122.359C250.829 128.842 256.472 137.39 254.001 143.354C251.48 149.424 241.42 151.468 237.815 156.859C234.174 162.299 236.114 172.366 231.507 176.972C226.901 181.579 216.826 179.639 211.394 183.28C205.996 186.892 203.959 196.952 197.889 199.466C191.925 201.937 183.377 196.294 176.894 197.575C170.6 198.822 164.867 207.335 158.209 207.335C151.551 207.335 145.818 198.822 139.524 197.575C133.041 196.294 124.493 201.937 118.529 199.466C112.459 196.945 110.415 186.885 105.024 183.28C99.5845 179.639 89.5174 181.579 84.9109 176.972C80.3044 172.366 82.2436 162.292 78.6032 156.859C74.9908 151.461 64.9307 149.424 62.4174 143.354C59.9462 137.39 65.5888 128.842 64.3077 122.359C63.0615 116.065 54.5486 110.332 54.5486 103.674C54.5486 97.0164 63.0615 91.2827 64.3077 84.989C65.5888 78.5063 59.9462 69.9584 62.4174 63.9937C64.9377 57.924 74.9978 55.8798 78.6032 50.4892C82.2436 45.0496 80.3044 34.9825 84.9109 30.376C89.5174 25.7695 99.5915 27.7087 105.024 24.0683C110.422 20.4559 112.459 10.3958 118.529 7.88254C124.493 5.41127 133.041 11.0539 139.524 9.77275C145.818 8.52661 151.551 0.0136719 158.209 0.0136719C164.867 0.0136719 170.6 8.52661 176.894 9.77275C183.377 11.0539 191.925 5.41127 197.889 7.88254C203.959 10.4028 206.003 20.4629 211.394 24.0683C216.833 27.7087 226.901 25.7695 231.507 30.376C236.114 34.9825 234.174 45.0566 237.815 50.4892C241.427 55.8868 251.487 57.924 254.001 63.9937C256.472 69.9584 250.829 78.5063 252.11 84.989C253.356 91.2827 261.869 97.0164 261.869 103.674Z",
    fill: "#FBD6CB"
  })), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    d: "M112.865 36.3193C112.865 36.3193 113.054 36.4804 113.341 36.8024C113.628 37.1314 114.034 37.6145 114.517 38.2235C115.49 39.4417 116.785 41.1569 118.13 43.1171C119.474 45.0773 120.601 46.9115 121.385 48.2626C121.777 48.9347 122.078 49.4878 122.281 49.8728C122.484 50.2579 122.582 50.4819 122.561 50.4889C122.512 50.5169 122.001 49.7048 121.168 48.3887C120.335 47.0795 119.173 45.2733 117.836 43.3201C116.498 41.3669 115.238 39.6307 114.321 38.3776C113.404 37.1244 112.83 36.3543 112.872 36.3193H112.865Z",
    fill: "#F05A30"
  })), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.2
  }, /*#__PURE__*/React.createElement("path", {
    d: "M84.8899 30.3681L115.343 57.0341L122.911 50.9784L105.241 23.8994C105.241 23.8994 103.89 24.8935 100.369 25.9016C96.9592 26.8747 86.9201 27.1338 84.8899 30.3751V30.3681Z",
    fill: "#F05A30"
  }))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.2
  }, /*#__PURE__*/React.createElement("path", {
    d: "M118.788 7.80471L133.657 45.0278L143.157 42.0525L139.993 9.76492C139.993 9.76492 138.355 10.15 134.728 9.68792C131.214 9.23987 122.673 5.9005 118.788 7.80471Z",
    fill: "#F05A30"
  }))), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.3
  }, /*#__PURE__*/React.createElement("path", {
    d: "M158.44 0.0124802L159.434 40.4349L168.339 40.862L177.356 9.83456C177.181 9.82056 174.857 9.41452 172.112 7.66432C169.025 5.69011 162.745 -0.309555 158.433 0.0124802H158.44Z",
    fill: "#F05A30"
  }))), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.2
  }, /*#__PURE__*/React.createElement("path", {
    d: "M197.28 7.65056L182.502 44.9157L190.546 48.7591L210.883 23.6543C210.729 23.5703 208.804 21.9671 207.018 19.1108C205.079 16.0025 201.775 8.88969 197.273 7.64355L197.28 7.65056Z",
    fill: "#F05A30"
  }))), _g7 || (_g7 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.2
  }, /*#__PURE__*/React.createElement("path", {
    d: "M231.99 30.9072L204.463 59.5964L210.596 67.8643L237.493 49.9143C237.493 49.9143 236.365 48.1221 235.721 44.6777C235.077 41.1914 234.979 34.8417 231.99 30.9142V30.9072Z",
    fill: "#F05A30"
  }))), _g8 || (_g8 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.2
  }, /*#__PURE__*/React.createElement("path", {
    d: "M253.72 63.2931L216.651 78.5478L219.725 88.0199L251.977 84.5195C251.977 84.5195 251.774 83.5254 252.201 79.885C252.614 76.3636 256.311 68.4947 253.72 63.2861V63.2931Z",
    fill: "#F05A30"
  }))), _g9 || (_g9 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.2
  }, /*#__PURE__*/React.createElement("path", {
    d: "M261.925 103.673L221.517 105.087L221.181 113.999L252.012 123.016C252.026 122.841 252.299 121.105 253.237 119.334C255.506 115.042 261.932 108.994 261.932 103.666L261.925 103.673Z",
    fill: "#F05A30"
  }))), _g0 || (_g0 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.2
  }, /*#__PURE__*/React.createElement("path", {
    d: "M254.484 141.891L217.274 127.386L213.508 135.472L238.823 155.55C238.9 155.396 240.377 154.024 243.219 152.217C246.307 150.25 253.629 147.065 254.484 141.891Z",
    fill: "#F05A30"
  }))), _g1 || (_g1 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.2
  }, /*#__PURE__*/React.createElement("path", {
    d: "M199.751 141.31L190.545 149.039C191.245 149.767 203.518 170.629 211.079 183.524C211.184 183.447 211.282 183.356 211.387 183.286C216.371 179.954 225.227 181.291 230.226 177.987L199.751 141.303V141.31Z",
    fill: "#F05A30"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M182.824 155.927L169.074 160.617L175.585 197.945C176.012 197.798 176.446 197.672 176.88 197.588C183.363 196.307 191.911 201.95 197.875 199.479C198.694 199.136 199.437 198.652 200.13 198.071L182.824 155.934V155.927Z",
    fill: "#F05A30"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M157.719 207.327L159.917 158.559L148.03 155.549L139.181 197.539C139.293 197.56 139.398 197.574 139.51 197.595C145.65 198.814 151.264 206.941 157.719 207.334V207.327Z",
    fill: "#F05A30"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M127.826 150.277C127.826 150.277 112.116 171.322 103.904 182.656C104.289 182.845 104.66 183.055 105.01 183.293C110.408 186.905 112.445 196.965 118.515 199.479C118.795 199.591 119.082 199.689 119.369 199.766L141.316 158.223L127.833 150.277H127.826Z",
    fill: "#F05A30"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M111.703 133.335L78.197 156.368C78.323 156.536 78.4631 156.697 78.5821 156.865C82.2225 162.304 80.2833 172.371 84.8898 176.978C85.3168 177.405 85.7999 177.755 86.3039 178.077C98.1422 164.734 119.397 140.777 120.167 139.944L111.703 133.328V133.335Z",
    fill: "#F05A30"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M104.023 116.897L64.4055 123.296C65.0356 129.653 60.03 137.676 62.3823 143.36C62.5293 143.71 62.7043 144.039 62.8934 144.361C76.7549 137.459 105.724 123.1 106.928 123.023L104.016 116.897H104.023Z",
    fill: "#F05A30"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M101.86 94.8307L64.4126 84.0215C64.3846 84.3505 64.3426 84.6726 64.2796 84.9876C63.0334 91.2813 54.5205 97.0149 54.5205 103.673C54.5205 104.121 54.5625 104.562 54.6325 105.003H100.341L101.86 94.8307Z",
    fill: "#F05A30"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M62.5433 63.6915C76.5379 71.1893 103.904 86.36 103.904 86.36L110.639 73.5696L79.0021 49.7529C78.8691 49.998 78.7361 50.25 78.5821 50.481C75.0327 55.7876 65.2666 57.8528 62.5433 63.6915Z",
    fill: "#F05A30"
  }))), _path1 || (_path1 = /*#__PURE__*/React.createElement("path", {
    d: "M145.928 165.602L141.308 187.675",
    stroke: "url(#paint0_linear_2666_16443)",
    strokeLinecap: "round"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M112.55 147.339L97.6748 164.289",
    stroke: "url(#paint1_linear_2666_16443)",
    strokeLinecap: "round"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M100.279 125.044L80.2216 135.353",
    stroke: "url(#paint2_linear_2666_16443)",
    strokeLinecap: "round"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M97.4193 104.488L74.8679 104.575",
    stroke: "url(#paint3_linear_2666_16443)",
    strokeLinecap: "round"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M102.588 85.2148L83.5996 74.2287",
    stroke: "url(#paint4_linear_2666_16443)",
    strokeLinecap: "round"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M119.015 60.5741L103.907 46.2008",
    stroke: "url(#paint5_linear_2666_16443)",
    strokeLinecap: "round"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M184.603 160.468L192.128 176.894",
    stroke: "url(#paint6_linear_2666_16443)",
    strokeLinecap: "round"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M213.1 134.801L227.613 145.564",
    stroke: "url(#paint7_linear_2666_16443)",
    strokeLinecap: "round"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M221.901 104.763L239.961 104.207",
    stroke: "url(#paint8_linear_2666_16443)",
    strokeLinecap: "round"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M215.741 78.8745L232.41 71.9026",
    stroke: "url(#paint9_linear_2666_16443)",
    strokeLinecap: "round"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M202.394 61.1664L215.187 48.4065",
    stroke: "url(#paint10_linear_2666_16443)",
    strokeLinecap: "round"
  })), _g10 || (_g10 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_i_2666_16443)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M158.189 166.84C193.094 166.84 221.389 138.545 221.389 103.64C221.389 68.736 193.094 40.4404 158.189 40.4404C123.285 40.4404 94.9891 68.736 94.9891 103.64C94.9891 138.545 123.285 166.84 158.189 166.84Z",
    fill: "#44454E"
  }))), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M153.911 76.6963C155.728 72.922 161.102 72.9209 162.921 76.6945L168.148 87.5432C168.867 89.035 170.278 90.0741 171.916 90.3181L183.801 92.0892C187.864 92.6947 189.504 97.6696 186.597 100.572L177.849 109.31C176.705 110.452 176.184 112.078 176.451 113.673L178.496 125.891C179.182 129.992 174.855 133.09 171.194 131.119L160.785 125.514C159.305 124.716 157.523 124.717 156.043 125.514L145.647 131.116C141.986 133.088 137.657 129.99 138.344 125.889L140.388 113.674C140.655 112.078 140.134 110.452 138.989 109.309L130.236 100.574C127.328 97.671 128.968 92.6945 133.032 92.0892L144.922 90.3182C146.561 90.0741 147.972 89.0342 148.691 87.5413L153.911 76.6963Z",
    fill: "#FBD6CB"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_i_2666_16443",
    x: 94.9891,
    y: 40.4404,
    width: 126.4,
    height: 126.4,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 4.2
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect1_innerShadow_2666_16443"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_2666_16443",
    x1: 143.618,
    y1: 165.602,
    x2: 143.618,
    y2: 187.675,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F05A30"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.985,
    stopColor: "#F1B8A7",
    stopOpacity: 0.5
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_2666_16443",
    x1: 110.538,
    y1: 146.203,
    x2: 99.6864,
    y2: 165.425,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F05A30"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.985,
    stopColor: "#F1B8A7",
    stopOpacity: 0.5
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_2666_16443",
    x1: 98.8247,
    y1: 123.25,
    x2: 81.676,
    y2: 137.148,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F05A30"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.985,
    stopColor: "#F1B8A7",
    stopOpacity: 0.5
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_2666_16443",
    x1: 96.9374,
    y1: 102.229,
    x2: 75.3498,
    y2: 106.834,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F05A30"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.985,
    stopColor: "#F1B8A7",
    stopOpacity: 0.5
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_2666_16443",
    x1: 103.316,
    y1: 82.7812,
    x2: 82.8713,
    y2: 76.6623,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F05A30"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.985,
    stopColor: "#F1B8A7",
    stopOpacity: 0.5
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_2666_16443",
    x1: 120.39,
    y1: 57.7734,
    x2: 102.532,
    y2: 49.0015,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F05A30"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.985,
    stopColor: "#F1B8A7",
    stopOpacity: 0.5
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint6_linear_2666_16443",
    x1: 183.231,
    y1: 161.441,
    x2: 193.5,
    y2: 175.921,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F05A30"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.985,
    stopColor: "#F1B8A7",
    stopOpacity: 0.5
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint7_linear_2666_16443",
    x1: 212.367,
    y1: 136.316,
    x2: 228.346,
    y2: 144.049,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F05A30"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.985,
    stopColor: "#F1B8A7",
    stopOpacity: 0.5
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint8_linear_2666_16443",
    x1: 222.265,
    y1: 106.405,
    x2: 239.597,
    y2: 102.564,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F05A30"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.985,
    stopColor: "#F1B8A7",
    stopOpacity: 0.5
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint9_linear_2666_16443",
    x1: 216.668,
    y1: 80.2786,
    x2: 231.483,
    y2: 70.4985,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F05A30"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.985,
    stopColor: "#F1B8A7",
    stopOpacity: 0.5
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint10_linear_2666_16443",
    x1: 203.784,
    y1: 62.1154,
    x2: 213.798,
    y2: 47.4575,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F05A30"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.985,
    stopColor: "#F1B8A7",
    stopOpacity: 0.5
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStarbadge);
export default __webpack_public_path__ + "static/media/starbadge.8636ff28aa351c0b3689564d5f30584d.svg";
export { ForwardRef as ReactComponent };